'use client'

import React, { useRef, useState, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight, faChevronLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons"

import 'swiper/css'
import 'swiper/css/navigation'

import { Navigation } from 'swiper/modules'
import Link from "next/link"
import { useGlobalContext } from "@/app/component/context/provider"
import { useAddToCart } from "@/app/component/Card/AddCart"
import Hashids from "hashids"
import { useRouter } from "next/navigation";
import { getLocalStorage } from "@/lib/localStorage"


// fan offset per volume index (i=0 left, i=1 center, i=2 right)
const FAN_CONFIG = [
    { tx: -38, rot: -7, scale: 0.93, z: 10 },
    { tx: 0, rot: 0, scale: 1.00, z: 30 },
    { tx: 38, rot: 7, scale: 0.93, z: 20 },
]

const BookSlideSetE = ({ data }) => {
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const { theme, privateKey } = useGlobalContext()
    const { addToCart, contextHolder } = useAddToCart()
    const router = useRouter()
    const Alldata = data[0]
    const [getpre, setGetpre] = useState([])

    useEffect(() => {
        const stored = getLocalStorage('Preorder')
        if (stored) {
            try {
                const parsed = typeof stored === 'string' ? JSON.parse(stored) : stored
                setGetpre(Array.isArray(parsed) ? parsed : [])
            } catch (e) {
                console.error('Error parsing Preorder from localStorage:', e)
            }
        }
    }, [])

    // ขนาดรูปแต่ละเล่ม (px) — center card
    const CARD_W = 110
    const CARD_H = 160

    // ระยะห่างระหว่าง slide ต้องให้ fan ไม่เบียดกัน
    const breakpoints = {
        0: {
            slidesPerView: 2,
            spaceBetween: CARD_W * 0.9, // เว้นพื้นที่ให้รูปซ้าย-ขวา
        },
        744: {
            slidesPerView: 3,
            spaceBetween: CARD_W * 0.85,
        },
        960: {
            slidesPerView: 4,
            spaceBetween: CARD_W * 0.8,
        },
        1280: {
            slidesPerView: 5,
            spaceBetween: CARD_W * 0.75,
        },
    }

    const OnDirectLinkPartner = (id) => {
        const hashids = new Hashids(privateKey, 6)
        const encodedID = hashids.encode(id)

        router.push(`/marketplace/${encodedID}_p`)
    }

    return (
        <>
            {contextHolder}
            {/* Section header — เหมือนกับ BookSlideSet อื่นๆ */}
            <div className="grid grid-cols-12 items-center text-[20px] xl:text-[24px] font-medium my-[0.5em]">
                <span className="flex items-center gap-[5px] w-full col-span-10">
                    <img
                        src="https://eve-image.eveebook.com/image.eveebook/mascot/happy.png"
                        alt="happy_rabbit"
                        className="w-[52px]"
                        loading="lazy"
                        decoding="async"
                        width={52}
                        height={52}
                    />
                    <div className="py-[24px] text-primary">{Alldata?.column_data?.order_name}</div>
                    <div className="text-special">{Alldata?.column_data?.order_discount}</div>
                </span>
                <Link href={`/preorder`} className="col-span-2 text-sm text-special text-end">ดูเพิ่มเติม</Link>
            </div>

            <div className="relative mx-0 md:mx-[5%] xl:mx-0">
                {/* Navigation buttons */}
                <div className="flex justify-between mb-2">
                    <button ref={prevRef} className="swiper-prev-btn EbookSetSwiper">
                        <FontAwesomeIcon size="2xl" icon={faChevronLeft} />
                    </button>
                    <button ref={nextRef} className="swiper-next-btn EbookSetSwiper">
                        <FontAwesomeIcon size="2xl" icon={faChevronRight} />
                    </button>
                </div>

                <Swiper
                    slidesPerView={2}
                    spaceBetween={CARD_W * 0.9}
                    modules={[Navigation]}
                    breakpoints={breakpoints}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    onInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current
                        swiper.params.navigation.nextEl = nextRef.current
                        swiper.navigation.init()
                        swiper.navigation.update()
                    }}
                >
                    {Alldata?.column_book
                        ?.slice()
                        .sort((a, b) => {
                            if (a?.sort_order != null && b?.sort_order != null) {
                                return a.sort_order - b.sort_order
                            }
                            const oA = Array.isArray(a?.order_id) ? (a.order_id[0]?.order ?? 0) : 0
                            const oB = Array.isArray(b?.order_id) ? (b.order_id[0]?.order ?? 0) : 0
                            return oA - oB
                        })
                        .map((campaign, index) => {
                            // console.log(campaign);

                            const volumes = (campaign?.volumes ?? []).slice(0, 3)
                            const bookTitle = campaign?.title
                            const preorderPrice = campaign?.preorder_price
                            const normalPrice = campaign?.normal_price

                            return (
                                <SwiperSlide key={index}>
                                    <Link
                                        href={`/preorder/${campaign.id}`}
                                        className="group flex flex-col items-center"
                                    >
                                        {/* Fan container — ความสูงรองรับรูป + shadow */}
                                        <div
                                            style={{
                                                position: 'relative',
                                                width: `${CARD_W}px`,
                                                height: `${CARD_H + 16}px`,
                                                margin: '0 auto',
                                            }}
                                        >
                                            {volumes.map((vol, i) => {
                                                const cfg = FAN_CONFIG[i] ?? FAN_CONFIG[1]
                                                return (
                                                    <div
                                                        key={vol.id}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: '50%',
                                                            width: `${CARD_W}px`,
                                                            height: `${CARD_H}px`,
                                                            marginLeft: `-${CARD_W / 2}px`,
                                                            transform: `translateX(${cfg.tx}px) rotate(${cfg.rot}deg) scale(${cfg.scale})`,
                                                            zIndex: cfg.z,
                                                            transformOrigin: 'bottom center',
                                                        }}
                                                        className="rounded-lg overflow-hidden border-2 border-white shadow-[0_8px_20px_rgba(0,0,0,0.18)] transition-transform duration-300 group-hover:scale-105"
                                                    >
                                                        <img
                                                            src={vol?.prebookseries?.book_image}
                                                            alt={`vol-${vol.volume_number}`}
                                                            className="w-full h-full object-cover"
                                                            loading="lazy"
                                                            decoding="async"
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>

                                        {/* Info ใต้รูป */}
                                        <div className="mt-3 h-[45px] w-full px-1">
                                            <p
                                                className="text-primary text-lg leading-tight"
                                                style={{
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                {bookTitle}
                                            </p>
                                        </div>
                                    </Link>
                                    <button onClick={() => OnDirectLinkPartner(campaign.partner_id)} className="w-full flex">
                                        <p className="text-start text-gray-500 text-sm">{campaign.partner.name}</p>
                                    </button>
                                    {preorderPrice && (
                                        <div className="flex items-center justify-between gap-1 mt-1">
                                            {normalPrice && (
                                                <span className="text-gray-400 text-sm line-through">
                                                    ฿{Number(normalPrice).toLocaleString()}
                                                </span>
                                            )}

                                            {getpre.includes(campaign.id) ? (
                                                <button className="pl-3 text-success text-[14px]">< FontAwesomeIcon icon={faCircleCheck} /> มีแล้ว</button>
                                            ) : (
                                                <span className="text-special text-md font-bold">
                                                    ฿{Number(preorderPrice).toLocaleString()}
                                                    <button onClick={(e) => {
                                                        // console.log('campaign', campaign);

                                                        e.stopPropagation();
                                                        const cartData = {
                                                            // book_series_id: bookSeriesId,
                                                            name: campaign.title,
                                                            series_number: 0,
                                                            partner_id: campaign.partner_id,
                                                            partner_name: campaign.partner.name,
                                                            coin_price: Number(campaign.preorder_price),
                                                            book_image: campaign?.book_data?.img,
                                                            // author: campaign?.book_data?.author,
                                                            preorder_id: campaign.id,
                                                            type: 'preorder_campaign'
                                                        }
                                                        addToCart(cartData);
                                                    }} className="pl-3">
                                                        <img
                                                            className="w-auto sm:h-[24px] h-[21px]"
                                                            src="https://eve-image.eveebook.com/image.eveebook/mascot/basket1.png"
                                                            alt="cart"
                                                            loading="lazy"
                                                            decoding="async"
                                                            width={24}
                                                            height={24}
                                                        />
                                                    </button>
                                                </span>

                                            )}


                                        </div>
                                    )}
                                </SwiperSlide>
                            )
                        })}
                </Swiper>
            </div>
        </>
    )
}

export default BookSlideSetE